<dt-table-layout *dtDataLoad="dataSource != null; error: hasError">
  <div header class="cp-filters-form">
    <button mat-raised-button color="primary" (click)="addVideo()"
      ><mat-icon>add</mat-icon><ng-container i18n>Video hinzufügen</ng-container></button
    >
  </div>

  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    [matSortDisableClear]="true"
    matSortActive="name"
    matSortDirection="asc"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>
    <ng-container matColumnDef="youtubeId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>YouTube ID</th>
      <td mat-cell *matCellDef="let row">{{ row.youtubeId }}</td>
    </ng-container>
    <ng-container matColumnDef="startTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Startzeit</th>
      <td mat-cell *matCellDef="let row">{{ row.startTime | secondsToHoursMinutesSeconds }}</td>
    </ng-container>
    <ng-container matColumnDef="step">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Schritte</th>
      <td mat-cell *matCellDef="let row">{{ row.steps }}</td>
    </ng-container>
    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Themengebiete</th>
      <td mat-cell *matCellDef="let row">{{ row.categories }}</td>
    </ng-container>
    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Aktualisiert am</th>
      <td mat-cell *matCellDef="let row">{{ row.updatedAt | date: 'medium' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="$event.defaultPrevented || showDetails(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" i18n>Keine Projekte entsprechen dem Filter.</td>
    </tr>
  </table>

  <dt-table-footer [visibleCount]="dataSource.data.length" [totalCount]="youtubeVideos.length"></dt-table-footer>
</dt-table-layout>
